var _defs, _polygon, _g, _polygon2, _polygon3, _path, _g2, _polygon4, _polygon5, _g3, _polygon6, _polygon7, _polygon8, _path2, _polygon9, _polygon10, _polygon11, _rect, _rect2, _g4, _rect3, _g5, _polygon12, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarbleArchLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st3 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st4 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st5 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st6 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st1 {\n        stroke: #1d1d1b;\n        stroke-width: .5px;\n      }\n\n      .st7 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1,
    y: 0.4,
    width: 298,
    height: 38.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1,
    y: 0.4,
    width: 298,
    height: 38.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1,
    y: 0.4,
    width: 298,
    height: 38.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1,
    y: 0.4,
    width: 298,
    height: 38.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1,
    y: 0.4,
    width: 298,
    height: 38.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1,
    y: 0.4,
    width: 298,
    height: 38.2
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "64.4 .7 59.8 12.4 55.2 .7 51.7 .7 51.7 16 53.9 16 53.9 3.1 54 3.1 59.2 16 60.5 16 65.7 3.1 65.7 3.1 65.7 16 68 16 68 .7 64.4 .7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.5,8.6c2.6,0,4.1-1,4.1-3s-1.4-2.9-3.4-2.9h-2.4v5.9h1.6ZM98,16l-5.1-7.1h0v7.1h-2.2V.7h4.9c3.7,0,5.3,1.9,5.3,5.1s-2.2,4.5-4.4,4.5l4.3,5.7h-2.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2,14c1.6,0,2.8-.9,2.8-2.4s-.7-2.4-2.7-2.4h-2.5v4.8h2.4ZM110.6,7.1c1.5,0,2.4-.7,2.4-2.2s-.9-2.2-2.6-2.2h-1.7v4.3h1.8ZM106.6,16V.7h4.2c2.8,0,4.6,1.8,4.6,4.2s-.4,2.1-1.4,3c1.5.8,2.3,2,2.3,3.7,0,2.7-2.1,4.5-4.8,4.5h-4.8Z"
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.6 .7 121.6 16 129.2 16 129.2 14 123.8 14 123.8 .7 121.6 .7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "133.5 .7 133.5 16 141.8 16 141.8 14 135.7 14 135.7 9.3 141.8 9.3 141.8 7.3 135.7 7.3 135.7 2.7 141.8 2.7 141.8 .7 133.5 .7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.8,3.6h0l1.9,5.9h-4l2-5.9h0ZM158.8.7l-5.8,15.3h2.4l1.7-4.5h5.5l1.7,4.5h2.4l-5.8-15.3h-2Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M175,8.6c2.6,0,4.1-1,4.1-3s-1.4-2.9-3.4-2.9h-2.4v5.9h1.6ZM178.4,16l-5.1-7.1h0v7.1h-2.2V.7h4.9c3.7,0,5.3,1.9,5.3,5.1s-2.2,4.5-4.4,4.5l4.3,5.7h-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,12.2c-1.6,2.7-4,4.1-7.1,4.1s-7.7-3.8-7.7-7.9,3.6-8,7.8-8,5.6,1.3,7.2,4.2h-2.7c-1.2-1.3-2.5-2.2-4.3-2.2-3.2,0-5.7,2.7-5.7,5.8s2.4,6,5.6,6,3-.6,4.3-2h2.8,0Z"
  })))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.3 .7 213.3 7.3 207 7.3 207 .7 204.7 .7 204.7 16 207 16 207 9.4 213.3 9.4 213.3 16 215.5 16 215.5 .7 213.3 .7"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.3 .7 239.3 7.3 233 7.3 233 .7 230.8 .7 230.8 16 233 16 233 9.4 239.3 9.4 239.3 16 241.6 16 241.6 .7 239.3 .7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260,8.4c0-3.2-2.4-5.9-5.6-5.9s-5.8,3.6-5.8,5.8,2.2,6,5.7,6,5.7-3.1,5.7-5.9M254.2,16.3c-4.2,0-7.8-3.6-7.8-7.8s3.6-8.1,7.9-8.1,8,3.6,8,7.8-3.6,8.1-8.1,8.1"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "265 .7 265 2.7 267.9 2.7 267.9 16 270.2 16 270.2 2.7 273.1 2.7 273.1 .7 265 .7"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "277.5 .7 277.5 16 285.8 16 285.8 14 279.8 14 279.8 9.3 285.8 9.3 285.8 7.3 279.8 7.3 279.8 2.7 285.8 2.7 285.8 .7 277.5 .7"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "291.4 .7 291.4 16 299 16 299 14 293.7 14 293.7 .7 291.4 .7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,3.6h0l1.9,5.9h-4l2-5.9h0ZM78.4.7l-5.8,15.3h2.4l1.7-4.5h5.5l1.7,4.5h2.4l-5.8-15.3h-2Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "1 .7 1 2.7 3.9 2.7 3.9 16 6.2 16 6.2 2.7 9.1 2.7 9.1 .7 1 .7"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.2 .7 22.2 7.3 15.9 7.3 15.9 .7 13.6 .7 13.6 16 15.9 16 15.9 9.3 22.2 9.3 22.2 16 24.4 16 24.4 .7 22.2 .7"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "30.4 .7 30.4 16 38.7 16 38.7 14 32.6 14 32.6 9.3 38.7 9.3 38.7 7.3 32.6 7.3 32.6 2.7 38.7 2.7 38.7 .7 30.4 .7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 31.6,
    width: 1.4,
    height: 1.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 33.1,
    width: 1.4,
    height: 4.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.4,34.9c-.6-.2-.9-.3-.9-.5s.2-.3.4-.3.4,0,.4.4h1.4c0-.9-.8-1.5-1.8-1.5s-1.8.6-1.8,1.5.3,1,1.5,1.4c.7.2.8.3.8.6s-.2.4-.5.4-.5-.1-.5-.4h-1.4c.1.9.8,1.5,1.9,1.5s1.9-.6,1.9-1.6-.4-1.1-1.5-1.4"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 31.6,
    width: 1.4,
    height: 6.2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.3,34.9c.1-.5.5-.8,1-.8s.9.3,1.1.8h-2.1ZM165.8,35.5c0-1.4-1.1-2.5-2.4-2.5s-2.4,1.1-2.4,2.5,1.1,2.4,2.4,2.4,1.8-.6,2.3-1.6h-1.4c-.2.3-.5.4-.8.4-.6,0-1-.3-1.1-.9h3.5c0-.1,0-.2,0-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,33c-.5,0-1,.2-1.2.6v-2h-1.4v1.5h-.6v-.9c0-.4-.3-.7-.7-.7h-.7v1.5h-.7v1h.7v3c0,.3.3.6.6.6h.8v-3.6h.6v3.6h1.4v-2.6c0-.6.2-.9.8-.9s.7.3.7.9v2.5h1.4v-2.9c0-1.2-.6-1.9-1.7-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,31.6h-.8v1.5h-.7v1.1h.7v3c0,.3.3.6.6.6h.8v-3.6h.7v-1.1h-.7v-1c0-.3-.3-.6-.6-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,37.6v-3.9h.9v1.2c.2-.2.5-.3.8-.3.8,0,1.4.6,1.4,1.5s-.6,1.6-1.5,1.6-.7-.2-.8-.4h0v.3h-.8ZM136.5,36.2c0-.4-.3-.7-.7-.7s-.7.3-.7.7.3.7.7.7.7-.3.7-.7"
  })))), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.5 34.7 139 36.4 138.9 36.4 138.4 34.7 137.4 34.7 138.5 37.5 138.1 38.6 139 38.6 140.4 34.7 139.5 34.7"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 170.6,
    y1: 35.1,
    x2: 299,
    y2: 35.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1,
    y1: 35.1,
    x2: 129.4,
    y2: 35.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarbleArchLogo);
export default __webpack_public_path__ + "static/media/MarbleArch-Logo.c879b7da4ed223f1c71b3c6ff898f211.svg";
export { ForwardRef as ReactComponent };